export default __webpack_public_path__ + "static/media/wallet-card-theme2.db0b7975.svg";